import { useMemo } from 'react';
import './App.css';
import './styles/fonts/inter/inter.css';
import {
    StateContext,
    usePersistedReducer,
    authReducer,
    authInitialState,
    menuReducer,
    menuInitialState,
    ApiCaller,
    StateContextPropertyType,
} from '@vegi.toenlioe/novitate-react-components';
import { BrowserRouter } from 'react-router-dom';
import { Box, CssBaseline, GlobalStyles } from '@mui/material';
import { GlobalStyleTemplate } from './styles';
import { OtherRoutes } from './utils/Routes';
import MainPage from './pages/MainPage';

function App() {
    const { state: authState, dispatch: setAuthState } = usePersistedReducer(authReducer, authInitialState, process.env.REACT_APP_AUTH_PERSIST_STORAGE_KEY);
    const { state: menuState, dispatch: setMenuState } = usePersistedReducer(menuReducer, menuInitialState, process.env.REACT_APP_MENU_PERSIST_STORAGE_KEY);

    const providerState: StateContextPropertyType = useMemo(() => {
        const apiCaller = new ApiCaller({authState});

        return {
            authState,
            setAuthState,
            menuState,
            setMenuState,
            apiCaller,
        };
    }, [authState, setAuthState, menuState, setMenuState]);

    return (
        <StateContext.Provider value={providerState}>
            <BrowserRouter>
                <GlobalStyles styles={GlobalStyleTemplate} />
				<Box
                    component="main"
                    sx={{
                        width: "100vw",
                        height: "100vh",
                        '@supports (height: 100dvh)': {
                            height: '100dvh',
                        },
                        display: "flex",
                        padding: 0, // Ensure no padding is applied
                        overflowX: 'hidden', // Hide any overflow on X-axis
                        backgroundColor: "#fefefe",
                    }}
                >
                    <CssBaseline />
                    {authState?.username && authState?.token ? (
                        <MainPage />
                    ) : (
                        <OtherRoutes />
                    )}
                </Box>
            </BrowserRouter>
        </StateContext.Provider>
    );
}

export default App;
